import type React from 'react'

import type { AddressreferenceOutcome } from '@/types/Landlord'
interface Props {
  label: AddressreferenceOutcome
}

const LandlordStatusDescription: React.FC<Props> = ({ label }) => {
  switch (label) {
    case 'Invalid':
      return (
        <p>
          This landlord reference is marked as <strong>Invalid</strong> as the landlord
          has indicated that they are not the right person to do the reference for this
          property.
        </p>
      )
    case 'Expired':
      return (
        <p>
          This landlord reference is marked as <strong>Expired</strong> because the
          landlord did not respond to the request.
        </p>
      )
    case 'Rejected':
      return (
        <p>
          This landlord reference is marked as <strong>Rejected</strong> as the landlord
          has indicated that they are the correct person to be the reference for the
          property, but the tenant did not rent from them at any point.
        </p>
      )
    case 'Fail':
      return (
        <p>
          This landlord reference is marked as a <strong>Fail</strong> as they have failed
          on one or more required conditions.
        </p>
      )
    case 'Pass':
      return (
        <p>
          This landlord reference is marked as a <strong>Pass</strong> as the answers from
          the landlord fufill our criteria.
        </p>
      )
    default:
      return (
        <p>
          This landlord reference is marked as <strong>Pending</strong> as we are waiting
          for the landlord to respond to the reference request.
        </p>
      )
  }
}

export default LandlordStatusDescription
